/**
 * 소셜 로그인 provider 로고 — 인라인 SVG.
 *
 * 기존 PNG 버튼 이미지(logo_kakao_btn.png 등)는 원형 아이콘 버튼용이라
 * 풀폭 버튼 안에 넣을 단색 마크가 없다. 구글은 자산 자체가 없다.
 * currentColor 를 쓰므로 버튼 텍스트 색을 그대로 따라간다(구글만 원본 4색 고정).
 */
export const KakaoLogo = (props: { className?: string; size?: number }) => (
    <svg
        width={props.size ?? 18}
        height={props.size ?? 18}
        viewBox="0 0 24 24"
        fill="currentColor"
        aria-hidden="true"
        className={props.className}
    >
        <path d="M12 1.5C5.94 1.5 1 5.39 1 10.19c0 3.06 2.01 5.75 5.04 7.29l-1.28 4.68c-.11.42.31.75.67.52l5.6-3.7c.32.03.64.04.97.04 6.06 0 11-3.89 11-8.69S18.06 1.5 12 1.5Z" />
    </svg>
);

export const NaverLogo = (props: { className?: string; size?: number }) => (
    <svg
        width={props.size ?? 14}
        height={props.size ?? 14}
        viewBox="0 0 24 24"
        fill="currentColor"
        aria-hidden="true"
        className={props.className}
    >
        <path d="M16.273 12.845 7.376 0H0v24h7.726V11.156L16.624 24H24V0h-7.727v12.845Z" />
    </svg>
);

export const GoogleLogo = (props: { className?: string; size?: number }) => (
    <svg
        width={props.size ?? 18}
        height={props.size ?? 18}
        viewBox="0 0 24 24"
        aria-hidden="true"
        className={props.className}
    >
        <path
            fill="#4285F4"
            d="M23.06 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h6.19a5.3 5.3 0 0 1-2.3 3.48v2.9h3.72c2.18-2 3.45-4.96 3.45-8.39Z"
        />
        <path
            fill="#34A853"
            d="M12 24c3.12 0 5.73-1.03 7.64-2.8l-3.72-2.89c-1.03.69-2.35 1.1-3.92 1.1-3.01 0-5.56-2.03-6.47-4.77H1.68v3A11.99 11.99 0 0 0 12 24Z"
        />
        <path fill="#FBBC05" d="M5.53 14.64a7.2 7.2 0 0 1 0-4.6v-3H1.68a12 12 0 0 0 0 10.6l3.85-3Z" />
        <path
            fill="#EA4335"
            d="M12 4.77c1.7 0 3.22.58 4.42 1.73l3.3-3.3C17.73 1.2 15.12 0 12 0 7.5 0 3.6 2.58 1.68 6.34l3.85 3C6.44 6.8 8.99 4.77 12 4.77Z"
        />
    </svg>
);
